
import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card } from '@/components/ui/card';
import { ChartContainer, ChartTooltipContent } from '@/components/ui/chart';

export interface MonthlyStats {
  name: string;
  totalReferrals: number;
  successfulReferrals: number;
  earnings: number;
}

interface ReferralStatsChartProps {
  data: MonthlyStats[];
}

const ReferralStatsChart: React.FC<ReferralStatsChartProps> = ({
  data
}) => {
  // Transform data for pie chart
  const pieData = [
    {
      name: 'Successful Referrals',
      value: data.reduce((acc, curr) => acc + curr.successfulReferrals, 0)
    },
    {
      name: 'Pending Referrals',
      value: data.reduce((acc, curr) => acc + (curr.totalReferrals - curr.successfulReferrals), 0)
    }
  ];

  const COLORS = ['#4ade80', '#93c5fd'];

  return (
    <Card className="p-6 flex flex-col items-center justify-center h-full">
      <h3 className="text-lg font-medium mb-6 text-center w-full">Referral Performance Overview</h3>
      <div className="h-[300px] w-full flex items-center justify-center px-4">
        <ChartContainer config={{
          successful: { color: "#4ade80" },
          pending: { color: "#93c5fd" }
        }} className="w-full max-w-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                outerRadius={100}
                dataKey="value"
                label={({name, percent}) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<ChartTooltipContent />} />
              <Legend 
                verticalAlign="bottom"
                wrapperStyle={{
                  paddingTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%"
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </ChartContainer>
      </div>
    </Card>
  );
};

export default ReferralStatsChart;
